import { lazy } from "react";

export const ArticlesTableAsync = lazy(() => import("./ArticlesTable"));
